import types from '../types'

const currencyChanged = (currency) => ({
  type: types.CURRENCY_CHANGED,
  payload: currency,
})

const languageChanged = (language) => ({
  type: types.LANGUAGE_CHANGED,
  payload: language,
})

export default {
  currencyChanged,
  languageChanged,
}
